import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import Functions from "./pages/Functions";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Preise from "./pages/Preise";
import News from "./pages/News";
import PublisherWerden from "./pages/PublisherWerden";
import Presse from "./pages/Presse";
import Impressum from "./pages/legal/Impressum";
import Datenschutz from "./pages/legal/Datenschutz";
import AGB from "./pages/legal/AGB";
import CookieRichtlinien from "./pages/legal/CookieRichtlinien";

const App = () => {
  console.log("🚀 Landing Page App Starting - Version:", new Date().toISOString());

  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          {/* PUBLIC ROUTES - Landing Page */}
          <Route path="/" element={<Index />} />

          {/* Content Pages */}
          <Route path="/functions" element={<Functions />} />
          <Route path="/funktionen" element={<Functions />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/preise" element={<Preise />} />
          <Route path="/news" element={<News />} />
          <Route path="/publisher-werden" element={<PublisherWerden />} />
          <Route path="/presse" element={<Presse />} />

          {/* Legal Pages */}
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/cookie-richtlinien" element={<CookieRichtlinien />} />

          {/* Redirect authenticated routes to main app */}
          <Route path="/login" element={<Navigate to="https://app.audioempire.ai/login" replace />} />
          <Route path="/dashboard" element={<Navigate to="https://app.audioempire.ai/dashboard" replace />} />
          <Route path="/audiobook-*" element={<Navigate to="https://app.audioempire.ai" replace />} />
          <Route path="/admin/*" element={<Navigate to="https://app.audioempire.ai" replace />} />

          {/* Catch all - 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  );
};

export default App;